<div class="main-content" *ngIf="glaccounts">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
							Journal Entry
						</h4>
						<p class="card-category text-right">
							<span *ngIf="reversalJournalNumber">Reversal of Journal #{{ reversalJournalNumber }} — </span>GL Journal Entry
						</p>
					</div>
					<div class="card-body">
						<div class="row">
							<!-- Left Panel: Form -->
							<div class="col-md-4">
								<form [formGroup]="accountForm" class="journal-form" (ngSubmit)="addValue()">
									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Journal Type</mat-label>
										<mat-select formControlName="type">
											<mat-option *ngFor="let type of journal_types" [value]="type">{{ type | uppercase }}</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Currency</mat-label>
										<mat-select formControlName="currcode">
											<mat-option value="">— Functional currency —</mat-option>
											<mat-option *ngFor="let cur of currencies" [value]="cur.currabrev">{{ cur.currabrev }} – {{ cur.currency }}</mat-option>
										</mat-select>
									</mat-form-field>

									<ng-container *ngIf="accountForm.get('currcode')?.value">
										<mat-form-field appearance="outline" class="full-width">
											<mat-label>Exchange Rate ({{ accountForm.get('currcode')?.value }} per CAD)</mat-label>
											<input matInput formControlName="exrate" type="number" step="0.000001" min="0.000001">
											<mat-hint>CAD = amount ÷ rate &nbsp;|&nbsp; ≈ {{ getFunctionalEquivalent() | currency:'CAD':'symbol':'1.2-2' }} CAD</mat-hint>
										</mat-form-field>
									</ng-container>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Transaction Date</mat-label>
										<input matInput [matDatepicker]="picker" formControlName="trandate">
										<mat-datepicker-toggle matSuffix [for]="picker">
											<mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
										</mat-datepicker-toggle>
										<mat-datepicker #picker></mat-datepicker>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Department{{ isDepartmentRequired() ? ' *' : '' }}</mat-label>
										<mat-select formControlName="department">
											<mat-option [value]="null">— None —</mat-option>
											<mat-option *ngFor="let tag of tags" [value]="tag">{{ tag.description }}</mat-option>
										</mat-select>
										<mat-error *ngIf="accountForm.get('department')?.hasError('required')">Department is required for expense GL accounts</mat-error>
									</mat-form-field>

									<app-gl-account-lookup (glselected)="addGl($event)" [reset]="resetjournal" [preselected]="preselectedAccount"></app-gl-account-lookup>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Description</mat-label>
										<input matInput formControlName="description" placeholder="Enter description" appSelectOnFocus>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Entry Type</mat-label>
										<mat-select formControlName="entryType">
											<mat-option value="debit">Debit</mat-option>
											<mat-option value="credit">Credit</mat-option>
										</mat-select>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>Amount</mat-label>
										<input matInput formControlName="debitcredit" type="number" step="0.01" min="0" placeholder="Enter amount">
									</mat-form-field>

									<div class="text-left d-flex gap-2">
										<button mat-raised-button color="accent" class="full-width" type="submit">{{ editingIndex !== null ? 'Update' : 'Add' }}</button>
										<button *ngIf="editingIndex !== null" mat-raised-button type="button" (click)="cancelEdit()">Cancel</button>
									</div>
								</form>
							</div>

							<!-- Right Panel: Summary -->
							<div class="col-md-8">
								<ng-container *ngIf="debits_credits.length">
									<div class="summary-header">
										<h4>Journal Summary</h4>
										<div class="action-buttons">
											<button mat-icon-button color="primary" (click)="exportXls()">
												<i class="fa fa-file-excel-o"></i>
											</button>
											<button mat-icon-button color="warn" (click)="exportPdf()">
												<i class="fa fa-file-pdf-o"></i>
											</button>
										</div>
									</div>

									<!-- Posting totals: what actually goes to the GL, both sides shown. -->
									<div class="gl-totals" [class.gl-totals--ok]="isBalanced()" [class.gl-totals--off]="!isBalanced()">
										<div class="gl-totals__cell">
											<span class="gl-totals__label">Lines</span>
											<span class="gl-totals__value">{{ debits_credits.length }}</span>
										</div>
										<div class="gl-totals__cell">
											<span class="gl-totals__label">Total Debit</span>
											<span class="gl-totals__value">{{ journalTotals.debit | currency }}</span>
										</div>
										<div class="gl-totals__cell">
											<span class="gl-totals__label">Total Credit</span>
											<span class="gl-totals__value">{{ journalTotals.credit | currency }}</span>
										</div>
										<div class="gl-totals__cell">
											<span class="gl-totals__label">Posting date{{ journalPostingDates().length > 1 ? 's' : '' }}</span>
											<span class="gl-totals__value gl-totals__value--dates">
												<span *ngFor="let d of journalPostingDates().slice(0, 3)">{{ d }}</span>
												<span *ngIf="journalPostingDates().length > 3">+{{ journalPostingDates().length - 3 }} more</span>
											</span>
										</div>
										<div class="gl-totals__cell gl-totals__cell--diff">
											<span class="gl-totals__label">{{ isBalanced() ? 'In balance' : 'Out by' }}</span>
											<span class="gl-totals__value">
												<mat-icon>{{ isBalanced() ? 'check_circle' : 'error_outline' }}</mat-icon>
												{{ journalTotals.difference | currency }}
											</span>
										</div>
									</div>

									<!-- Dates, before the fact. A line keeps the date it was keyed under, and
									     a date inside the closed GL is rolled forward on post — both are things
									     to see now, not to find later in the trial balance. -->
									<div class="alert alert-warning gl-date-notice" *ngIf="closedDateLineCount()">
										<mat-icon>event_busy</mat-icon>
										<span>
											<strong>{{ closedDateLineCount() }} line(s)</strong> are dated on or before the GL close
											({{ glClosedThroughDate }}) and will post to <strong>{{ todayYmd() }}</strong> instead.
											Reopen the period under General Ledger maintenance to post them as keyed.
										</span>
									</div>

									<div class="alert alert-info gl-date-notice" *ngIf="linesOffHeaderDate()">
										<mat-icon>info_outline</mat-icon>
										<span>
											<strong>{{ linesOffHeaderDate() }} line(s)</strong> are dated differently from the
											Transaction Date field ({{ headerTranYmd() }}) — each line keeps the date it was added under.
										</span>
										<button mat-stroked-button type="button" class="ml-auto" (click)="applyHeaderDateToAllLines()" [disabled]="posting">
											Use {{ headerTranYmd() }} for all lines
										</button>
									</div>

									<div class="table-responsive" #print_table>
										<table class="table table-striped">
											<thead>
												<tr>
													<th>Post date</th>
													<th>Account</th>
													<th>Description</th>
													<th>Department</th>
													<th class="text-center">Type</th>
													<th class="text-right">Debit</th>
													<th class="text-right">Credit</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let d of debits_credits; let i = index" [class.table-warning]="editingIndex === i">
													<td class="gl-line-date" [class.gl-line-date--moved]="lineDateClosed(d)">
														{{ lineEffectiveYmd(d) || '—' }}
														<mat-icon *ngIf="lineDateClosed(d)"
															matTooltip="Keyed {{ lineTranYmd(d) }} — that period is closed, so it posts on {{ todayYmd() }}">
															event_busy
														</mat-icon>
													</td>
													<td>{{ d.account.accountcode }} - {{ d.account.accountname }}</td>
													<td>{{ d.description }}</td>
													<td>{{ d.department?.description ?? '—' }}</td>
													<td class="text-center">
														<span class="badge" [ngClass]="d.debitcredit >= 0 ? 'badge-success' : 'badge-info'">
															{{ d.debitcredit >= 0 ? 'DEBIT' : 'CREDIT' }}
														</span>
													</td>
													<td class="text-right">
														<span *ngIf="d.debitcredit >= 0">{{ d.debitcredit | currency }}</span>
													</td>
													<td class="text-right">
														<span *ngIf="d.debitcredit < 0">{{ (d.debitcredit * -1) | currency }}</span>
													</td>
													<td>
														<button mat-icon-button color="primary" (click)="editLine(d, i)" [disabled]="editingIndex !== null && editingIndex !== i" matTooltip="Edit line">
															<mat-icon>edit</mat-icon>
														</button>
														<button mat-icon-button color="warn" (click)="removeDC(d)">
															<mat-icon>delete</mat-icon>
														</button>
													</td>
												</tr>
												<tr>
													<td><b>Total</b></td>
													<td></td>
													<td></td>
													<td></td>
													<td></td>
													<td class="text-right"><b>{{ getDebitTotal() | currency }}</b></td>
													<td class="text-right"><b>{{ getCreditTotal() | currency }}</b></td>
													<td></td>
												</tr>
											</tbody>
										</table>
									</div>

									<!-- Batched post progress. A file of thousands of lines goes up in
									     chunks, so the operator sees movement instead of a dead button. -->
									<div class="gl-post-progress mt-3" *ngIf="posting">
										<mat-progress-bar mode="determinate"
											[value]="postProgress.total ? (postProgress.done / postProgress.total) * 100 : 0">
										</mat-progress-bar>
										<div class="gl-post-progress__text">
											<mat-spinner diameter="16"></mat-spinner>
											Posting {{ postProgress.done | number }} of {{ postProgress.total | number }} lines
											<span *ngIf="postProgress.transno"> — journal #{{ postProgress.transno }}</span>
										</div>
									</div>

									<!-- Only asked when a line actually lands on a bank account: mirroring is
										 the right default there, and a reclass is the exception that has to say so. -->
									<div class="gl-bank-movement mt-3" *ngIf="journalHitsBankAccount()">
										<mat-checkbox [(ngModel)]="noBankMovement" [ngModelOptions]="{standalone: true}" [disabled]="posting">
											This journal moves no money through the bank
										</mat-checkbox>
										<div class="text-muted small">
											Leave unticked for payroll, transfers and fees — the bank line is written so the
											reconciliation can match it. Tick it for a reclass between bank accounts, where the
											money never actually moved.
										</div>
									</div>

									<div class="text-right mt-3">
										<button mat-stroked-button type="button" color="primary" class="mr-2" [disabled]="!debits_credits.length || posting" (click)="openJournalGlPreview()">
											Preview GL
										</button>
										<button mat-raised-button color="primary" [disabled]="!isBalanced() || posting" (click)="postJournal()">
											<mat-spinner diameter="18" class="mr-2" *ngIf="posting"></mat-spinner>
											{{ posting ? 'Posting…' : 'Post Journal' }}
										</button>
									</div>
								</ng-container>

								<ng-container *ngIf="!debits_credits.length">
									<div class="empty-state">
										<mat-icon>note_add</mat-icon>
										<h5>Start Adding Entries</h5>
										<p>Values will display here as you enter them.</p>
									</div>
								</ng-container>

								<div class="row mt-3 align-items-end">
									<div class="col-md-12">
										<h5 class="mb-2">Attachments</h5>
										<ngx-dropzone (change)="onAttachmentSelect($event)" class="dropzone-attachments">
											<ngx-dropzone-label>Drop or click (PDF, images, Word, Excel)</ngx-dropzone-label>
											<ngx-dropzone-preview *ngFor="let f of attachmentFiles" [removable]="true" (removed)="onAttachmentRemove(f)">
												<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
											</ngx-dropzone-preview>
										</ngx-dropzone>
									</div>
								</div>

								<!-- ---------- Bank close-out: shown once a payroll journal has posted ----------
								     Each cash line is matched on its own. One payroll run leaves the bank as
								     several separate withdrawals (net direct deposit, tax collection, 401k),
								     which only agree with the journal line by line — never in total. -->
								<div class="gl-payroll-bank mt-4" *ngIf="payrollPostedTransno && payrollCashLines.length">
									<div class="gl-payroll-bank__head">
										<mat-icon>account_balance</mat-icon>
										<span>Bank close-out — journal <strong>#{{ payrollPostedTransno }}</strong></span>
										<mat-spinner diameter="18" class="ml-2" *ngIf="payrollBankBusy"></mat-spinner>
										<button mat-icon-button class="ml-auto" (click)="dismissPayrollBankPanel()" matTooltip="Close">
											<mat-icon>close</mat-icon>
										</button>
									</div>
									<p class="gl-payroll-note">
										Pick the bank line each cash posting settles. Nothing is linked until you press
										Close out, and a bank line already accounted for elsewhere can't be picked twice.
									</p>

									<div class="gl-payroll-bank__line" *ngFor="let line of payrollBankLines">
										<div class="gl-payroll-bank__line-head">
											<span class="gl-payroll-bank__amt" [class.gl-payroll-bank__amt--out]="line.amount < 0">
												{{ line.amount | currency }}
											</span>
											<span class="gl-payroll-bank__acct">{{ line.erpAccount }} <span *ngIf="line.accountName">— {{ line.accountName }}</span></span>
											<span class="gl-payroll-bank__desc">{{ line.description }}</span>
											<span class="gl-payroll-bank__done" *ngIf="line.linked"><mat-icon>check_circle</mat-icon> closed</span>
										</div>

										<p class="gl-payroll-note mb-1" *ngIf="line.note">{{ line.note }}</p>

										<div class="gl-payroll-bank__cands" *ngIf="line.candidates?.length && !line.linked">
											<label class="gl-payroll-bank__cand" *ngFor="let c of line.candidates">
												<input type="radio" [name]="'sfline' + line.index" [value]="c.sf_id"
													[(ngModel)]="line.selected" [ngModelOptions]="{ standalone: true }"
													[disabled]="payrollCandidateTaken(line, c.sf_id)">
												<span class="gl-payroll-bank__cand-date">{{ c.posted }}</span>
												<span class="gl-payroll-bank__cand-amt">{{ c.amount | currency }}</span>
												<span class="gl-payroll-bank__cand-desc">{{ c.description }}</span>
												<span class="gl-payroll-bank__cand-meta">
													{{ c.dayGap }}d
													<span *ngIf="c.hintScore > 0"> · name {{ (c.hintScore * 100) | number:'1.0-0' }}%</span>
													<span *ngIf="c.pending"> · pending</span>
													<span *ngIf="payrollCandidateTaken(line, c.sf_id)"> · picked on another line</span>
												</span>
											</label>
											<button mat-button class="gl-payroll-bank__skip" (click)="line.selected = ''" *ngIf="line.selected">
												Clear selection
											</button>
										</div>

										<!-- Split withdrawals: several feed rows that add up to this one posting.
										     Never pre-selected — numbers adding up is a coincidence often enough
										     that it has to be a decision. -->
										<div class="gl-payroll-bank__cands" *ngIf="line.groups?.length && !line.linked">
											<label class="gl-payroll-bank__cand gl-payroll-bank__cand--group"
												*ngFor="let g of line.groups; let gi = index">
												<input type="radio" [name]="'sfgroup' + line.index" [value]="gi"
													[(ngModel)]="line.selectedGroup" [ngModelOptions]="{ standalone: true }">
												<span class="gl-payroll-bank__cand-desc">
													<span class="gl-payroll-bank__grp-title">{{ g.count }} lines together</span>
													<span class="gl-payroll-bank__grp-member" *ngFor="let m of g.members">
														{{ m.posted }} · {{ m.amount | currency }} · {{ m.description }}
													</span>
												</span>
											</label>
											<button mat-button class="gl-payroll-bank__skip" (click)="line.selectedGroup = -1" *ngIf="line.selectedGroup >= 0">
												Clear selection
											</button>
										</div>
									</div>

									<div class="gl-payroll-bank__actions">
										<button mat-raised-button color="primary"
											(click)="linkPayrollBankLines()"
											[disabled]="payrollBankBusy || !payrollSelectedCount()">
											<mat-icon>link</mat-icon>
											Close out {{ payrollSelectedCount() }} bank line(s)
										</button>
										<button mat-stroked-button class="ml-2" (click)="loadPayrollBankCandidates()" [disabled]="payrollBankBusy">
											<mat-icon>refresh</mat-icon> Re-check the feed
										</button>
										<span class="gl-batch-error ml-3" *ngIf="payrollBankNotice">{{ payrollBankNotice }}</span>
									</div>
								</div>

								<!-- Launcher. The importer itself opens as a full-size dialog: a
								     column-mapping grid does not fit in a panel this wide. -->
								<div class="gl-import-launch mt-4">
									<button mat-raised-button color="primary" (click)="openGlImportDialog()" [disabled]="posting">
										<mat-icon>cloud_upload</mat-icon> Import from file
									</button>
									<span class="gl-import-launch__hint">
										CSV or Excel — standard GL upload, or a payroll provider's journal export.
									</span>
								</div>

								<ng-template #glImportDialog>
								<div class="gl-import-dialog">
									<div class="gl-import-dialog__head">
										<mat-icon>cloud_upload</mat-icon>
										<h2>Import lines into this journal</h2>
										<span class="gl-import-dialog__file" *ngIf="glUploadReady">
											{{ glUploadFiles[0]?.name }} · {{ glUploadedRawData.length | number }} row(s)
										</span>
										<button mat-icon-button class="ml-auto" (click)="closeGlImportDialog()" matTooltip="Close">
											<mat-icon>close</mat-icon>
										</button>
									</div>

									<div class="gl-import-dialog__body">

										<!-- Payroll switch: turns the generic dropper into a payroll-provider importer -->
										<div class="gl-payroll-switch">
											<mat-slide-toggle
												[checked]="glImportMode === 'payroll'"
												(change)="setGlImportMode($event.checked ? 'payroll' : 'standard')">
												Payroll file
											</mat-slide-toggle>
											<span class="gl-payroll-switch__hint" *ngIf="glImportMode === 'standard'">
												Off — the file's account column must already hold your GL codes.
											</span>
											<span class="gl-payroll-switch__hint" *ngIf="glImportMode === 'payroll'">
												On — translates a payroll provider's codes to your GL, blocks a double post,
												and closes the cash lines against the bank feed.
											</span>
										</div>

										<div class="gl-import-parsing" *ngIf="glParsing">
											<mat-spinner diameter="28"></mat-spinner>
											<span>Reading the file…</span>
										</div>

										<!-- Drop zone (shown when no file loaded) -->
										<ng-container *ngIf="!glUploadReady && !glParsing">
											<div class="gl-dropzone"
												[class.gl-dropzone--active]="glDropzoneActive"
												(dragover)="onGlDropzoneDragOver($event)"
												(dragleave)="onGlDropzoneDragLeave($event)"
												(drop)="onGlDropzoneDrop($event)"
												(click)="glFileInput.click()">
												<input type="file" #glFileInput class="d-none" accept=".csv,.xlsx,.xls" (change)="onGlUploadChange($event)">
												<mat-icon class="gl-dropzone__icon">upload_file</mat-icon>
												<p class="gl-dropzone__primary">Drop your file here, or <span class="gl-dropzone__link">browse</span></p>
												<p class="gl-dropzone__hint">Supports .csv, .xlsx, .xls — first row must be headers</p>
											</div>
											<div class="gl-batch-format mt-3">
												<div class="gl-batch-format__chips">
													<span class="gl-chip gl-chip--required">account <span class="gl-chip__note">GL code</span></span>
													<span class="gl-chip gl-chip--required">debitcredit <span class="gl-chip__note">one signed column: + debit / − credit</span></span>
												<span class="gl-chip gl-chip--required">debit + credit <span class="gl-chip__note">…or two separate columns</span></span>
													<span class="gl-chip gl-chip--required">department <span class="gl-chip__note">required for expense accounts (6/7xxx); tag name or ID</span></span>
													<span class="gl-chip gl-chip--optional">trandate <span class="gl-chip__note">optional</span></span>
													<span class="gl-chip gl-chip--optional">description <span class="gl-chip__note">optional</span></span>
												</div>
												<button mat-stroked-button class="mt-2" (click)="downloadGlUploadTemplate()">
													<mat-icon>file_download</mat-icon> Download template
												</button>
											</div>
										</ng-container>

										<!-- Mapping + preview (shown after file is loaded) -->
										<ng-container *ngIf="glUploadReady && glUploadedRawData.length && !glParsing">
											<div class="gl-batch-file-bar">
												<mat-icon>insert_drive_file</mat-icon>
												<span class="gl-batch-file-bar__name">{{ glUploadFiles[0]?.name }}</span>
												<span class="gl-batch-file-bar__count">{{ glUploadedRawData.length }} row(s)</span>
												<button mat-icon-button class="ml-auto" (click)="clearGlUpload()" matTooltip="Remove file">
													<mat-icon>close</mat-icon>
												</button>
											</div>

											<p class="gl-batch-map-hint mt-2 mb-1">Map each column to a field, or leave as <em>ignore</em>. Files with separate debit and credit columns use <strong>debit</strong> and <strong>credit</strong>; a single signed column uses <strong>debitcredit</strong>. If the file has expense accounts (6xxx/7xxx), map a column to <strong>department</strong>.</p>

											<!-- ---------- Payroll: layout, translation, double-post guard ---------- -->
											<ng-container *ngIf="glImportMode === 'payroll'">

												<div class="alert alert-danger gl-payroll-block mt-2" *ngIf="payrollDuplicate">
													<strong>This exact file already posted.</strong>
													Journal #{{ payrollDuplicate.transno }} on {{ payrollDuplicate.droppedAt }}<span *ngIf="payrollDuplicate.postedBy"> by {{ payrollDuplicate.postedBy }}</span>
													<span *ngIf="payrollDuplicate.sourceName"> ({{ payrollDuplicate.sourceName }})</span>.
													<div class="mt-2">
														<mat-checkbox [(ngModel)]="payrollDuplicateOverridden" [ngModelOptions]="{ standalone: true }">
															Post it again anyway — this really is a re-run
														</mat-checkbox>
													</div>
												</div>

												<div class="gl-payroll-card mt-2">
													<div class="gl-payroll-card__head">
														<mat-icon>badge</mat-icon>
														<span *ngIf="payrollProfile">Layout: <strong>{{ payrollProfile.name }}</strong></span>
														<span *ngIf="!payrollProfile">New layout — name it once and every future file of this shape maps itself</span>
														<mat-spinner diameter="18" class="ml-2" *ngIf="payrollBusy"></mat-spinner>
													</div>
													<div class="gl-payroll-card__row">
														<mat-form-field appearance="outline" class="gl-payroll-field">
															<mat-label>Payroll provider / layout name</mat-label>
															<input matInput [(ngModel)]="payrollProfileName" [ngModelOptions]="{ standalone: true }" placeholder="e.g. Paylocity">
														</mat-form-field>
														<mat-form-field appearance="outline" class="gl-payroll-field">
															<mat-label>Bank statement text (optional)</mat-label>
															<input matInput [(ngModel)]="payrollFeedHint" [ngModelOptions]="{ standalone: true }" placeholder="e.g. PAYLOCITY">
															<mat-hint>How this provider's withdrawals read on the bank feed</mat-hint>
														</mat-form-field>
														<button mat-stroked-button color="primary" (click)="savePayrollProfile()" [disabled]="payrollBusy">
															<mat-icon>save</mat-icon> {{ payrollProfile ? 'Update layout' : 'Save layout' }}
														</button>
													</div>
													<p class="gl-payroll-note mb-0" *ngIf="payrollNotice">{{ payrollNotice }}</p>
												</div>

												<!-- Bank feed readiness — close-out is useless if the cash account
												     is not wired to SimpleFIN / a dropped statement. Say so before
												     the journal posts, not after. -->
												<div class="gl-payroll-card mt-2"
													*ngIf="payrollFeedStatus"
													[class.gl-payroll-card--ok]="payrollFeedOk()"
													[class.gl-payroll-card--warn]="!payrollFeedOk()">
													<div class="gl-payroll-card__head">
														<mat-icon>{{ payrollFeedOk() ? 'account_balance' : 'warning' }}</mat-icon>
														<span *ngIf="payrollFeedOk()">
															Bank feed configured
															<span *ngIf="payrollCashErpAccounts().length">
																— {{ payrollCashErpAccounts().join(', ') }} ready for close-out after posting
															</span>
															<span *ngIf="!payrollCashErpAccounts().length">
																— cash lines will be offered for close-out after posting
															</span>
														</span>
														<span *ngIf="!payrollFeedOk()">{{ payrollFeedWarning() }}</span>
													</div>
													<p class="gl-payroll-note mb-0" *ngIf="!payrollFeedOk()">
														Import still works; only the bank close-out step will be empty until this is fixed under Bank Rec → Connections.
													</p>
												</div>

												<!-- Codes we cannot translate. Blocking: a payroll line dropped in
												     silence is worse than an import that refuses to start. -->
												<div class="gl-payroll-card gl-payroll-card--warn mt-2" *ngIf="payrollUnmapped.length">
													<div class="gl-payroll-card__head">
														<mat-icon>rule</mat-icon>
														<span><strong>{{ payrollUnmapped.length }}</strong> code(s) in this file don't exist in your chart — point each one at a GL account.</span>
													</div>
													<p class="gl-payroll-note" *ngIf="!payrollProfile">Save the layout above first — the answers are stored against it.</p>
													<div class="table-responsive">
														<table class="table table-sm gl-payroll-table">
															<thead>
																<tr>
																	<th>File code</th>
																	<th>Description</th>
																	<th>Post to GL account</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let u of payrollUnmapped">
																	<td><code>{{ u.sourceCode }}</code></td>
																	<td>{{ u.sourceDesc || '—' }}</td>
																	<td>
																		<mat-form-field appearance="outline" class="gl-payroll-picker">
																			<input matInput [(ngModel)]="u.pick" [ngModelOptions]="{ standalone: true }"
																				[matAutocomplete]="acct" placeholder="Search code or name">
																			<mat-autocomplete #acct="matAutocomplete">
																				<mat-option *ngFor="let a of payrollAccountOptions(u.pick)" [value]="a.accountcode">
																					{{ a.accountcode }} — {{ a.accountname }}
																				</mat-option>
																			</mat-autocomplete>
																		</mat-form-field>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
													<button mat-raised-button color="primary" (click)="savePayrollMappings()" [disabled]="payrollBusy || !payrollProfile">
														<mat-icon>done_all</mat-icon> Save mappings
													</button>
												</div>

												<!-- What the file will actually post to, once everything resolves. -->
												<div class="gl-payroll-card gl-payroll-card--ok mt-2" *ngIf="payrollProfile && !payrollUnmapped.length && payrollResolvedList().length">
													<div class="gl-payroll-card__head">
														<mat-icon>check_circle</mat-icon>
														<span>All {{ payrollResolvedList().length }} code(s) translate.
															<strong *ngIf="payrollCashResolvedList().length">{{ payrollCashResolvedList().length }}</strong>
															<span *ngIf="payrollCashResolvedList().length"> will be offered for bank close-out after posting.</span>
														</span>
													</div>
													<div class="table-responsive">
														<table class="table table-sm gl-payroll-table">
															<thead>
																<tr>
																	<th>File code</th>
																	<th>Description</th>
																	<th>GL account</th>
																	<th>Cash?</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let r of payrollResolvedList()">
																	<td><code>{{ r.sourceCode }}</code></td>
																	<td>{{ r.sourceDesc || '—' }}</td>
																	<td>{{ r.erpAccount }} — {{ r.accountName }}</td>
																	<td>
																		<span class="gl-chip gl-chip--required" *ngIf="r.isCash">bank</span>
																		<span *ngIf="!r.isCash">—</span>
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
												</div>
											</ng-container>

											<div class="gl-upload-validation mt-2" *ngIf="glUploadInvalidAccounts.length || glUploadInvalidDates.length || glUploadClosedPeriodHits.length">
												<div class="alert alert-danger mb-2" *ngIf="glUploadInvalidAccounts.length">
													<strong>Invalid GL accounts</strong>
													<ul class="mb-0 pl-3 mt-1">
														<li *ngFor="let e of glUploadInvalidAccounts.slice(0, 40)">Row {{ e.row }}: {{ e.code }}</li>
													</ul>
													<p class="mb-0 mt-1" *ngIf="glUploadInvalidAccounts.length > 40">…and {{ glUploadInvalidAccounts.length - 40 }} more.</p>
												</div>
												<div class="alert alert-danger mb-2" *ngIf="glUploadInvalidDates.length">
													<strong>Unrecognized transaction dates</strong>
													<ul class="mb-0 pl-3 mt-1">
														<li *ngFor="let e of glUploadInvalidDates.slice(0, 40)">Row {{ e.row }}: {{ e.value }}</li>
													</ul>
													<p class="mb-0 mt-1" *ngIf="glUploadInvalidDates.length > 40">…and {{ glUploadInvalidDates.length - 40 }} more.</p>
												</div>
												<div class="alert alert-warning mb-0" *ngIf="glUploadClosedPeriodHits.length">
													<strong>Dates on or before GL close</strong> — these lines will post to the first open period (often today) per company policy.
													<ul class="mb-0 pl-3 mt-1">
														<li *ngFor="let e of glUploadClosedPeriodHits.slice(0, 40)">Row {{ e.row }}: {{ e.date }}</li>
													</ul>
													<p class="mb-0 mt-1" *ngIf="glUploadClosedPeriodHits.length > 40">…and {{ glUploadClosedPeriodHits.length - 40 }} more.</p>
												</div>
											</div>

											<!-- Column mapping. Always visible — it is the decision the
											     screen exists to collect. -->
											<div class="table-responsive gl-batch-table-wrap gl-batch-table-wrap--map">
												<table class="table table-sm table-bordered gl-batch-table">
													<thead>
														<tr class="gl-batch-table__map-row">
															<th *ngFor="let h of glUploadedHeaders" class="gl-batch-table__map-cell">
																<mat-form-field appearance="outline" class="gl-batch-select">
																	<mat-select [value]="glColumnMappings[h]" (selectionChange)="onGlColumnMappingChange(h, $event.value)">
																		<mat-option *ngFor="let type of glAvailableFieldTypes" [value]="type">{{ type }}</mat-option>
																	</mat-select>
																</mat-form-field>
																<div class="gl-batch-table__col-name">{{ h }}</div>
															</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td *ngFor="let h of glUploadedHeaders" class="gl-batch-table__data-cell gl-batch-table__sample">
																{{ glUploadedRawData[0] ? glUploadedRawData[0][h] : '' }}
															</td>
														</tr>
													</tbody>
												</table>
											</div>

											<!-- Raw data: collapsed by default. It is a correction tool, and
											     rendering thousands of live inputs is the most expensive thing
											     on this screen — so it only renders when asked for. -->
											<mat-expansion-panel class="gl-raw-panel mt-3" [(expanded)]="glRawDataExpanded">
												<mat-expansion-panel-header>
													<mat-panel-title><mat-icon class="mr-1">table_chart</mat-icon> Edit file data</mat-panel-title>
													<mat-panel-description>
														{{ glUploadedRawData.length | number }} row(s) — open only if something needs correcting
													</mat-panel-description>
												</mat-expansion-panel-header>

												<ng-container *ngIf="glRawDataExpanded">
													<div class="table-responsive gl-batch-table-wrap">
														<table class="table table-sm table-bordered gl-batch-table">
															<thead>
																<tr>
																	<th class="gl-batch-table__rownum">#</th>
																	<th *ngFor="let h of glUploadedHeaders">{{ h }}</th>
																</tr>
															</thead>
															<tbody>
																<tr *ngFor="let row of glRawRows(); let i = index">
																	<td class="gl-batch-table__rownum">{{ i + 1 }}</td>
																	<td *ngFor="let h of glUploadedHeaders" class="gl-batch-table__data-cell">
																		<input class="gl-batch-edit-input" [(ngModel)]="row[h]" (ngModelChange)="refreshGlUploadValidation()" type="text" [attr.aria-label]="'Edit ' + h" />
																	</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div class="gl-raw-more" *ngIf="!glRawShowAll && glRawHiddenCount()">
														Showing the first {{ glRawPreviewLimit }} rows.
														<button mat-button color="primary" (click)="glRawShowAll = true">
															Show all {{ glUploadedRawData.length | number }}
														</button>
													</div>
												</ng-container>
											</mat-expansion-panel>
										</ng-container>

									</div>

									<!-- Sticky footer: the totals that will hit the GL, and the action. -->
									<div class="gl-import-dialog__foot" *ngIf="glUploadReady && glUploadedRawData.length">
										<div class="gl-totals gl-totals--compact"
											[class.gl-totals--ok]="isUploadBatchBalanced()"
											[class.gl-totals--off]="!isUploadBatchBalanced()">
											<div class="gl-totals__cell">
												<span class="gl-totals__label">Lines to post</span>
												<span class="gl-totals__value">{{ glUploadTotals.lines | number }}</span>
											</div>
											<div class="gl-totals__cell">
												<span class="gl-totals__label">Total Debit</span>
												<span class="gl-totals__value">{{ glUploadTotals.debit | currency }}</span>
											</div>
											<div class="gl-totals__cell">
												<span class="gl-totals__label">Total Credit</span>
												<span class="gl-totals__value">{{ glUploadTotals.credit | currency }}</span>
											</div>
											<div class="gl-totals__cell gl-totals__cell--diff">
												<span class="gl-totals__label">{{ isUploadBatchBalanced() ? 'In balance' : 'Out by' }}</span>
												<span class="gl-totals__value">
													<mat-icon>{{ isUploadBatchBalanced() ? 'check_circle' : 'error_outline' }}</mat-icon>
													{{ glUploadTotals.difference | currency }}
												</span>
											</div>
										</div>

										<div class="gl-import-dialog__actions">
											<span class="gl-batch-error mr-3" *ngIf="glError">
												<mat-icon>warning</mat-icon> {{ glError }}
											</span>
											<button mat-stroked-button (click)="closeGlImportDialog()">Cancel</button>
											<button mat-raised-button color="primary"
												class="ml-2 gl-batch-post-btn"
												(click)="importGlUploadToJournal()"
												[disabled]="!hasRequiredGlMappings() || payrollBusy">
												<mat-spinner diameter="18" class="mr-2" *ngIf="payrollBusy"></mat-spinner>
												<mat-icon *ngIf="!payrollBusy">playlist_add</mat-icon>
												Add {{ glUploadTotals.lines | number }} line(s) to journal
											</button>
										</div>
									</div>
								</div>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>